<template>
    <div class="container">

        <div class="h5 text-center mt-4">
            <slot></slot> {{ getRemainingTime }}
        </div>

    </div>
</template>

<script>
    export default {

        props: [
            'timeout'
        ],

        data() {
            return {
                interval: null,
                remainingTime: 0,
            }
        },

        mounted() {

            this.remainingTime = this.timeout;

            this.interval = setInterval(() => {
                this.remainingTime--;
            }, 1000);

        },

        computed: {
            getRemainingTime() {

                let remaining = this.remainingTime;

                if (remaining <= 0) {
                    remaining = 0;
                }

                let minutes = Math.floor(remaining / 60);

                let seconds = (remaining % 60).toFixed(0);

                return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;

            }
        },

        watch: {
            remainingTime: function (val) {
                if (val <= 0) {
                    location.reload();
                }
            }
        }

    }
</script>
